angular.module('app').factory('ContentAttributeService',
    ['ContentAttributeRepository',  'LocalStorageRepository', '$q', 'AppId', 'UrlParsingService', '$location',
        function(ContentAttributeRepository, LocalStorageRepository, $q, AppId, UrlParsingService, $location) {
            'use strict';

            var contentAttributes = null;

            function getAttributeValue(id) {
                if (!contentAttributes) {
                    return '';
                }

                var attributeValue = _.filter(contentAttributes, function(attribute) {
                    return attribute.Id.toLowerCase() === id.toLowerCase();
                });
                return attributeValue[0].Value;
            }

            function loadContentAttributes() {
                var clientId = LocalStorageRepository.getClientID();
                var clientURL = LocalStorageRepository.getClientURL();

                if (!clientId || !clientURL) {
                    return $q.when();
                }

                return ContentAttributeRepository
                    .getContentAttributes(clientId)
                    .then(function (data) {
                        contentAttributes = data;
                        return;
                    });
            }

            function getPracticeInfo(forceRefresh) {
                if (!contentAttributes || forceRefresh) {
                    var promise = loadContentAttributes()
                        .then(function() {
                            return createPracticeInfo();
                        });
                    return promise;
                }

                return $q.when(createPracticeInfo());

                function createPracticeInfo() {
                    return {
                        practiceName: getAttributeValue(AppId.PracticeName),
                        practiceTagline: getAttributeValue(AppId.PracticeTagline),
                    };
                }
            }

            function getPracticeName(forceRefresh) {
                return getPracticeInfo(forceRefresh).then(function(practiceInfo) {
                    return practiceInfo.practiceName;
                });
            }

            function getMessageSubHeading(forceRefresh) {
                if (!contentAttributes || forceRefresh) {
                    var promise = loadContentAttributes()
                        .then(function() {
                            return getAttributeValue(AppId.MessageSubHeader);
                        });
                    return promise;
                }

                return $q.when(getAttributeValue(AppId.MessageSubHeader));
            }

            function getClientConfig() {
                return UrlParsingService.parsePortalUrl('/portal/');
            }

            function getPaymentRedirectUrl() {
                var absPath = $location.absUrl(),
                    partial = $location.path(),
                    newPartial = '/transactionComplete/';
                var redirectUrl = absPath.replace(partial, newPartial);
                return redirectUrl;
            }

            return {
                loadContentAttributes: loadContentAttributes,
                getPracticeInfo: getPracticeInfo,
                getPracticeName: getPracticeName,
                getMessageSubHeading: getMessageSubHeading,
                getClientConfig: getClientConfig,
                getPaymentRedirectUrl: getPaymentRedirectUrl,
            };

        }]);